import type { UserResponse } from "@/api/users";

/** True when both first and last name are non-empty after trim (Kinde may return ""). */
export function hasFirstAndLastName(user: UserResponse): boolean {
	const first = user.firstName?.trim() ?? "";
	const last = user.lastName?.trim() ?? "";
	return first.length > 0 && last.length > 0;
}
